import { abreviaturas } from 'constantes';
import endPoints from 'endPoints/endPoints';
import { IO } from '../io/IO';

// Se extrae la ruta
const { auth, terms } = endPoints || {};

export class LoginDao {
    static async fetchKCLoginToken(data) {
        return IO.fetchKCLoginToken(data);
    }

    static async fetchClientDomain(data) {
        return IO.fetchClientDomain(data);
    }

    static async loginLionClient(clientUrl, dataForm) {
        return IO.loginLionClient(clientUrl, dataForm);
    }

    static async verificarDominioAuth(data) {
        return IO.verificarDominioAuth(data);
    }

    static async verificarDominio(data) {
        return IO.verificarDominio(data);
    }

    static async obtenerTokenKeycloak(data) {
        return IO.apiFetch(data, auth.getTokenKeycloack, abreviaturas.DEFAULT_POST);
    }

    static async login(data) {
        return IO.login(data, abreviaturas.TYPE_TOKEN_AUTH, abreviaturas.DEFAULT_POST);
    }

    static async sendEmailOTPCode() {
        return IO.apiFetch(null, auth.sendCodeOTP, abreviaturas.DEFAULT_POST);
    }

    static async validateEmailOTPCode(data) {
        return IO.apiFetch(data, auth.validCodeOTP, abreviaturas.DEFAULT_POST);
    }

    static async getVersionTermsAndConditions() {
        return IO.apiFetch(null, terms.getTermsVersion, abreviaturas.DEFAULT_GET);
    }

    static async saveTermsAndConditions(version) {
        return IO.apiFetch(version, terms.base, abreviaturas.DEFAULT_POST);
    }

    static async obtenerCompaniasUsuario(data, text) {
        return IO.apiFetch(data, auth.getCompanias, abreviaturas.DEFAULT_POST, text);
    }

    static async getTermsAndConditionsPDF() {
        return IO.apiFetch(null, terms.getTermsPDF, abreviaturas.DEFAULT_GET);
    }
}
